'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_shopping$package$GroceryItemId$() {
  this.ZT = null;
  $n_Lmealorama_shopping$package$GroceryItemId$ = this;
  this.ZT = ($m_Lmealorama_shopping$package$GroceryItemId$(), "");
}
export { $c_Lmealorama_shopping$package$GroceryItemId$ as $c_Lmealorama_shopping$package$GroceryItemId$ };
$p = $c_Lmealorama_shopping$package$GroceryItemId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_shopping$package$GroceryItemId$;
/** @constructor */
function $h_Lmealorama_shopping$package$GroceryItemId$() {
}
export { $h_Lmealorama_shopping$package$GroceryItemId$ as $h_Lmealorama_shopping$package$GroceryItemId$ };
$h_Lmealorama_shopping$package$GroceryItemId$.prototype = $p;
var $d_Lmealorama_shopping$package$GroceryItemId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_shopping$package$GroceryItemId$, "mealorama.shopping$package$GroceryItemId$", ({
  LT: 1
}));
export { $d_Lmealorama_shopping$package$GroceryItemId$ as $d_Lmealorama_shopping$package$GroceryItemId$ };
var $n_Lmealorama_shopping$package$GroceryItemId$;
function $m_Lmealorama_shopping$package$GroceryItemId$() {
  if ((!$n_Lmealorama_shopping$package$GroceryItemId$)) {
    $n_Lmealorama_shopping$package$GroceryItemId$ = new $c_Lmealorama_shopping$package$GroceryItemId$();
  }
  return $n_Lmealorama_shopping$package$GroceryItemId$;
}
export { $m_Lmealorama_shopping$package$GroceryItemId$ as $m_Lmealorama_shopping$package$GroceryItemId$ };
//# sourceMappingURL=mealorama.shopping$package$-Grocery-Item-Id$.js.map
